// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"672":"c3301953","676":"5d9764bf","872":"948da7d5"}[chunkId] + ".chunk.css";
};